module.exports = __webpack_public_path__ + "img/speedometer.116c62a0.svg";